import { FullStoryAPI } from "@zapier/react-fullstory";
import { emit } from "@zapier/events-toolkit-browser";
import {
  createAvroEventsHub,
  RemoveAutoPopulatedEventFields,
  WebAnalyticsTrackingUserInteractionUserInteractionEvent,
} from "@zapier/avro-events";

import { InteractionName, UserInteractionEvent } from "./trackingTypes";

const avroEvent = createAvroEventsHub<typeof UserInteractionEvent>();
avroEvent.emitFunction = emit;

export const emitEvent = (
  name: InteractionName,
  properties: Omit<
    RemoveAutoPopulatedEventFields<WebAnalyticsTrackingUserInteractionUserInteractionEvent.EventFields>,
    "system_name"
  >
) => {
  const payload = {
    ...properties,
    interaction_name: name,
    system_name: "@zapier/trials",
  };

  avroEvent.emit(payload, UserInteractionEvent);

  FullStoryAPI("event", name, payload as { [property: string]: any });
};
